import React from 'react';
import { getStudentDisplayName } from '../utils/studentName';

/**
 * StudentSelector Component
 *
 * Dropdown for selecting a student in the Session Planner.
 * Shows student name, grade level, and subjects.
 */
const StudentSelector = ({
  students,
  selectedStudentUuid,
  onSelect,
  loading = false,
  disabled = false
}) => {
  const handleChange = (e) => {
    const uuid = e.target.value || null;
    onSelect(uuid);
  };

  // Find the selected student for display
  const selectedStudent = students.find(s => s.uuid === selectedStudentUuid);

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
      <label
        htmlFor="student-select"
        className="sp-label"
        style={{ marginBottom: 0, whiteSpace: 'nowrap' }}
      >
        Student:
      </label>
      <select
        id="student-select"
        value={selectedStudentUuid || ''}
        onChange={handleChange}
        disabled={disabled || loading}
        className="sp-select"
        style={{ minWidth: '200px' }}
      >
        <option value="">
          {loading ? 'Loading students...' : '-- Choose a student --'}
        </option>
        {students.map(student => (
          <option key={student.uuid} value={student.uuid}>
            {getStudentDisplayName(student)}
          </option>
        ))}
      </select>

      {selectedStudent && (
        <div className="sp-tags">
          <span className="sp-tag">{selectedStudent.grade_year_level}</span>
          {selectedStudent.target_subjects && (
            <span className="sp-tag sp-tag--accent">
              {selectedStudent.target_subjects.split(',').slice(0, 2).join(', ')}
            </span>
          )}
        </div>
      )}
    </div>
  );
};

export default StudentSelector;
